"use strict";
/**
 * Optional host-registered script APIs (e.g. Collabajam `@collabajam/csm`).
 * Merged into every adventure script context; registration is sync so helpers
 * can run inside `new Function` evaluation.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerScriptApi = registerScriptApi;
exports.unregisterScriptApi = unregisterScriptApi;
exports.clearScriptApiExtensions = clearScriptApiExtensions;
exports.getScriptApiExtensions = getScriptApiExtensions;
const extensions = Object.create(null);
/**
 * Register or replace a script API by name.
 * Prefer stable names that are also listed in {@link ADVENTURE_SCRIPT_RESERVED_NAMES}.
 */
function registerScriptApi(name, value) {
    const key = String(name || '').trim();
    if (!key) {
        throw new Error('registerScriptApi: name is required');
    }
    extensions[key] = value;
}
/** Remove a previously registered script API. */
function unregisterScriptApi(name) {
    const key = String(name || '').trim();
    if (!key) {
        return;
    }
    delete extensions[key];
}
/** Remove all registered script APIs (tests). */
function clearScriptApiExtensions() {
    for (const key of Object.keys(extensions)) {
        delete extensions[key];
    }
}
/** Snapshot of currently registered APIs (shallow copy). */
function getScriptApiExtensions() {
    return { ...extensions };
}
//# sourceMappingURL=scriptApiExtensions.js.map